import PropTypes from "prop-types";
import DateTime from 'react-datetime';
import moment from "moment";
import "react-datetime/css/react-datetime.css";


const FieldDateTime = ({
                           id,
                           minDate,
                           iconBefore,
                           iconAfter,
                           wrapperClasses,
                           inputClasses,
                           field,
                           isEditing,
                           timeConstraints,
                           form: {touched, errors, setFieldValue}
                       }) => {

    const handleChange = date => {
        const dateValidation = moment(date, 'MM/DD/YYYY', true).isValid();
        if (dateValidation) {
            setFieldValue("date", date.toISOString());
        } else {
            const currentDate = moment().toISOString();
            setFieldValue("date", currentDate);
        }
    }
    const {value, onChange, ...otherFields} = field;

    const valid = function (current) {
        return current.isAfter(moment(minDate).subtract(1, 'days'));
    };

    if (minDate)
        otherFields.isValidDate = valid

    return (
        <div className={"mb-6 " + wrapperClasses}>
            <div className="field FieldDateTime input-group flex py-2 px-2 mb-2 shadow">
                {iconBefore &&
                    <span
                        className="flex items-center justify-center px-3  text-gray-400	">
                   {iconBefore}
                </span>
                }
                <DateTime
                    value={moment(value).toDate()}
                    {...otherFields}
                    timeConstraints={timeConstraints}
                    onChange={handleChange}
                    className={"w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none bg-white focus:shadow-outline " + inputClasses}
                    inputProps={{disabled: isEditing}}
                />
                {iconAfter &&
                    <span
                        className="flex items-center justify-center px-3 pr-6 text-gray-400	">
                    {iconAfter}
                </span>
                }
            </div>
            {touched[field.name] &&
                <p className="text-red-500 text-xs italic">{errors[field.name]}</p>
            }
        </div>
    )
}

export default FieldDateTime;

FieldDateTime.propTypes = {
    id: PropTypes.string,
    minDate: PropTypes.object,
    iconBefore: PropTypes.element,
    iconAfter: PropTypes.element,
    field: PropTypes.object,
    form: PropTypes.object,
    wrapperClasses: PropTypes.string,
    inputClasses: PropTypes.string,
    isEditing: PropTypes.bool,
    timeConstraints: PropTypes.object,
}
